import { Config } from 'config/envConfig';
//settingsContent.jsx
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUserCog,
    faAngleRight,
    faSave,
} from '@fortawesome/free-solid-svg-icons';
import { Button } from '@quyva/shared-ui';
import { SettingSections } from './settingsView';
import { AccountSettingsComponent } from './settingsSections/accountSettings';
import { Features, SettingsFeatures, isFeatureEnabled } from '@quyva/common';
import { useFeatureFlags } from '../../context';
import { PromptListView } from './settingsSections/promptSettings/promptListView';
import BeforeSelectPrompts from './settingsSections/promptSettings/beforeSelectPrompts';
import { useSettingsContext } from '../../context';
import { GeneralSettings } from './settingsSections/generalSettings';
import { OrganizationSettings } from './settingsSections/organization/organizationSettings';
import { OrganizationManagementSettings } from './settingsSections/organization/orgnizationManagementSettings';
import SystemSettings from './settingsSections/systemSettings';
import { MaintenanceSettings } from './settingsSections/maintenanceSettings';

export const SettingsContent = ({
    activeSection,
    accountDetails,
    setAccountDetails,
    // refine,
    // onRefineChange,
    accountSettingsRef,
    generalSettingsRef,
    // chatsSettingsRef,
    organizationSettingsRef,
    organizationManagementRef,
    promptSettingsRef,
    systemSettingsRef,
    maintenanceRef,
    historyCounts,
    setHistoryCounts,
    isAdmin,
    setActiveSection,
    rootRef,
    organizationId,
    organizationName,
    organizationAddress,
    organizationWebsite,
    organizationOwner,
    organizationIndustry,
    userRole,
    setOrganizationName,
    setOrganizationAddress,
    setOrganizationWebsite,
    setOrganizationOwner,
    setOrganizationIndustry,
    organizationTenantId,
    setOrganizationTenantId,
    teamsEnabled,
    setTeamsEnabled,
    setUserRole,
    fetchOrganizationDetails,
    orgQueryLimit,
    setOrgQueryLimit,
    isPostpaid,
}) => {
    const { featureFlagsData } = useFeatureFlags();
    const {
        runWithSaving,
        saveGeneralSection,
        savePromptSection,
        saveSystemSettingsSection,
        isGeneralDirty,
        promptHasChanges,
        isSystemSettingsDirty,
        processes,
        loadPromptSection,
        selectedProcess,
        handleInstructionChange,
        handlePromptNameChange,
        isSuperAdmin,
        isUserKey,
    } = useSettingsContext();

    const formatProcessName = (name) => {
        if (!name) return '';
        return name
            .toLowerCase()
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const user = JSON.parse(localStorage.getItem('current'));
    const [selectedPrompt, setSelectedPrompt] = useState(null);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 1024px)');
        const handleResize = (e) => {
            setIsSmallScreen(e.matches);
        };

        // Initial check
        setIsSmallScreen(mediaQuery.matches);

        // Listen for changes in screen size
        mediaQuery.addEventListener('change', handleResize);

        // Cleanup
        return () => {
            mediaQuery.removeEventListener('change', handleResize);
        };
    }, []);

    const currentProcess = processes.find(
        (p) => p.process_name === selectedProcess
    );

    useEffect(() => {
        if (activeSection !== SettingSections.PROMPT_SETTINGS) return;
        if ((processes || []).length > 0) return;
        loadPromptSection?.();
    }, [activeSection, processes, loadPromptSection]);

    return (
        <div className='flex flex-col w-full justify-center text-texts-secondary'>
            {activeSection === SettingSections.ACCOUNT &&
                isFeatureEnabled(
                    [Features.SETTINGS, SettingsFeatures.ACCOUNT_SETTINGS],
                    featureFlagsData
                ) && (
                    <div ref={accountSettingsRef}>
                        <AccountSettingsComponent
                            user={user}
                            accountDetails={accountDetails}
                            setAccountDetails={setAccountDetails}
                            SettingSections={SettingSections}
                            isSmallScreen={isSmallScreen}
                        />
                    </div>
                )}
            {activeSection === SettingSections.GENERAL &&
                isFeatureEnabled(
                    [Features.SETTINGS, SettingsFeatures.GENERAL_SETTINGS],
                    featureFlagsData
                ) && (
                    <GeneralSettings
                        SettingSections={SettingSections}
                        generalSettingsRef={generalSettingsRef}
                        historyCounts={historyCounts}
                        setHistoryCounts={setHistoryCounts}
                        runWithSaving={runWithSaving}
                        saveGeneralSection={saveGeneralSection}
                        isGeneralDirty={isGeneralDirty}
                    />
                )}

            {activeSection === SettingSections.ORGANIZATION &&
                isFeatureEnabled(
                    [Features.SETTINGS, SettingsFeatures.ORGANIZATION_SETTINGS],
                    featureFlagsData
                ) && (
                    <OrganizationSettings
                        SettingSections={SettingSections}
                        organizationSettingsRef={organizationSettingsRef}
                    />
                )}

            {activeSection === SettingSections.ORGANIZATION_MANAGEMENT &&
                isSuperAdmin &&
                isFeatureEnabled(
                    [
                        Features.SETTINGS,
                        SettingsFeatures.ORGANIZATION_MANAGEMENT,
                    ],
                    featureFlagsData
                ) && (
                    <OrganizationManagementSettings
                        SettingSections={SettingSections}
                        organizationManagementRef={organizationManagementRef}
                    />
                )}

            {activeSection === SettingSections.SYSTEM_SETTINGS &&
                isSuperAdmin && isUserKey &&
                isFeatureEnabled(
                    [Features.SETTINGS, SettingsFeatures.SYSTEM_SETTINGS],
                    featureFlagsData
                ) && (
                    <div ref={systemSettingsRef}>
                        <SystemSettings />
                    </div>
                )}

            {activeSection === SettingSections.PROMPT_SETTINGS &&
                isAdmin &&
                isFeatureEnabled(
                    [Features.SETTINGS, SettingsFeatures.PROMPT_SETTINGS],
                    featureFlagsData
                ) && (
                    <div ref={promptSettingsRef}>
                        <div className='flex items-center justify-between font-semibold mb-2 py-3 px-4 text-texts-secondary300 bg-backgrounds-primary100 truncate'>
                            <div className='flex items-center justify-between w-full'>
                                <div className='flex items-center'>
                                    <FontAwesomeIcon
                                        icon={faUserCog}
                                        className='mr-2'
                                    />
                                    <div className='font-semibold text-texts-secondary300 uppercase truncate mr-2'>
                                        {SettingSections.PROMPT_SETTINGS}
                                    </div>

                                    {selectedProcess && (
                                        <>
                                            <FontAwesomeIcon
                                                icon={faAngleRight}
                                                className='mr-2'
                                            />
                                            <span>
                                                {formatProcessName(
                                                    selectedProcess
                                                )}
                                            </span>
                                            <span className='ml-1'>
                                                (
                                                {
                                                    currentProcess?.sub_tasks
                                                        ?.length
                                                }
                                                )
                                            </span>
                                        </>
                                    )}
                                    {selectedPrompt && (
                                        <>
                                            <FontAwesomeIcon
                                                icon={faAngleRight}
                                                className='mx-2'
                                            />
                                            <span>{selectedPrompt}</span>
                                        </>
                                    )}
                                </div>
                                <Button
                                    type='success'
                                    icon={faSave}
                                    text={'Save'}
                                    disabled={!promptHasChanges}
                                    hoverText='Save prompt settings'
                                    onClick={() =>
                                        runWithSaving(async () => {
                                            await savePromptSection();
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className='h-[calc(100vh-210px)] w-full overflow-auto'>
                            {/* {Main Content Section} */}
                            {selectedProcess ? (
                                <PromptListView
                                    processes={processes}
                                    currentProcess={currentProcess}
                                    selectedProcess={selectedProcess}
                                    selectedPrompt={selectedPrompt}
                                    setSelectedPrompt={setSelectedPrompt}
                                    isPersonaProcess={false}
                                    isAdmin={isAdmin}
                                    handleInstructionChange={(idx, val) =>
                                        handleInstructionChange?.(idx, val)
                                    }
                                    handlePromptNameChange={(idx, val) =>
                                        handlePromptNameChange?.(idx, val)
                                    }
                                    formatProcessName={formatProcessName}
                                    normalizePromptName={(name) =>
                                        String(name || '').trim()
                                    }
                                    normalizePromptKey={(name) =>
                                        String(name || '')
                                            .trim()
                                            .toLowerCase()
                                    }
                                    promptDomId={(processName, promptName) =>
                                        `prompt-${String(processName || 'unknown')}-${String(
                                            promptName || ''
                                        )
                                            .trim()
                                            .toLowerCase()}`
                                    }
                                />
                            ) : (
                                <BeforeSelectPrompts />
                            )}
                        </div>
                    </div>
                )}

            {activeSection === SettingSections.MAINTENANCE && isSuperAdmin && (
                <MaintenanceSettings
                    SettingSections={SettingSections}
                    maintenanceRef={maintenanceRef}
                />
            )}

            {/* {isFeatureEnabled(
                [Features.SETTINGS, SettingsFeatures.CHAT_SETTINGS],
                featureFlagsData
            ) && (
                <div className='mb-6'>
                    <div
                        ref={chatsSettingsRef}
                        className='flex items-center font-semibold my-6 py-3 px-4 text-texts-secondary300 uppercase bg-backgrounds-primary100 truncate'
                    >
                        <FontAwesomeIcon icon={faComments} className='mr-2' />
                        <div className='font-semibold text-texts-secondary300 uppercase truncate'>
                            {SettingSections.CHATS}
                        </div>
                    </div> */}
        </div>
    );
};